module.exports = __webpack_public_path__ + "static/img/格物智安工地安全管理平台操作说明-3.d64acb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentation/格物智安工地安全管理平台操作说明-3.jpg
// module id = lVgH
// module chunks = 0